import { useFormat } from '@ideavivat/vivat-2';
import useWithdraw from '@/use/useWithdraw';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    material: {
      name: 'ชิ้นส่วน',
      width: '1fr',
      class: {
        cell: 'has-multiselect text-center',
      },
    },
    amount: {
      name: 'จำนวนที่ขอเบิก / เบิกแล้ว',
      width: '12rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
      filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    },
    // filledAmount: {
    //   name: 'เบิกไปแล้ว',
    //   width: '5rem',
    //   class: {
    //     cell: 'text-center',
    //     text: 'text-right',
    //   },
    //   filter: (val: string) => parseFloat(val || '0').toLocaleString('th-TH', { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
    // },
    addedAmount: {
      name: 'จำนวนที่ให้เบิก',
      width: '8rem',
      class: {
        cell: 'text-center',
        text: 'text-right',
      },
    },
    'bom_item.unit': {
      name: 'หน่วย',
      width: '5rem',
      class: 'text-left',
    },
  },
};
